<template>
  <div>
    <b-row v-if="data.length > 0">
      <b-col
        v-for="item in data"
        :key="item.id"
        cols="12"
        xl="6"
        md="12"
      >
        <b-card
          no-body
          class="card-developer-meetup"
        >
          <!-- Imagen -->
          <div class="bg-light-primary rounded-top text-center">
            <b-img
              :src="(item.imagen) ? item.imagen : 'https://www.indetec.gob.mx/assets/img/banner_index/banner1.jpg'"
              alt="Meeting Pic"
              style="height: 100%; width: 100%"
            />
          </div>
          <b-card-body>
            <!-- header -->
            <div class="meetup-header d-flex align-items-center">
              <!-- Fecha (Mes - Día) -->
              <div class="meetup-day">
                <h6 class="mb-0">
                  {{
                    (item.calendario && item.calendario.length && getCalendarDates(item.calendario, 3) && getCalendarDates(item.calendario, 3).fechaIni)
                      ? title(timestampToDate(getCalendarDates(item.calendario, 3).fechaIni, 'MMMM'))
                      : '-'
                  }}
                </h6>
                <h3 class="mb-0">
                  {{
                    (item.calendario && item.calendario.length && getCalendarDates(item.calendario, 3) && getCalendarDates(item.calendario, 3).fechaIni)
                      ? timestampToDate(getCalendarDates(item.calendario, 3).fechaIni, 'D')
                      : '-'
                  }}
                </h3>
              </div>
              <!-- Nombre y descripción -->
              <div class="my-auto">
                <b-card-title class="mb-25">
                  {{ item.nombre }}
                </b-card-title>
              </div>
            </div>
            <!--/ header -->

            <!-- media -->
            <b-row class="mx-0">
              <b-col
                md="12"
                class="budget-wrapper"
              >
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="34"
                    >
                      <feather-icon
                        icon="CalendarIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      <b>Inicio de curso</b>
                    </h6>
                    <small>
                      {{
                        (item.calendario && item.calendario.length && getCalendarDates(item.calendario, 3) && getCalendarDates(item.calendario, 3).fechaIni)
                          ? timestampToDate(getCalendarDates(item.calendario, 3).fechaIni)
                          : 'Fecha sin registrar'
                      }}
                    </small>
                  </b-media-body>
                </b-media>
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="34"
                    >
                      <feather-icon
                        icon="CalendarIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      <b>Inscripciones</b>
                    </h6>
                    <small>
                      <b>
                        {{
                          (item.calendario && item.calendario.length && getCalendarDates(item.calendario, 2) && getCalendarDates(item.calendario, 2).fechaIni)
                            ? timestampToDate(getCalendarDates(item.calendario, 2).fechaIni)
                            : '-'
                        }}
                      </b>
                      al
                      <b>
                        {{
                          (item.calendario && item.calendario.length && getCalendarDates(item.calendario, 2) && getCalendarDates(item.calendario, 2).fechaFin)
                            ? timestampToDate(getCalendarDates(item.calendario, 2).fechaFin)
                            : '-'
                        }}
                      </b>
                    </small>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col
                lg="12"
                class="d-flex justify-content-between flex-column mt-1"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  :to="'/detalle-especialidad/' + item.id"
                >
                  Detalles
                </b-button>
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div
      v-else
      class="text-center"
    >
      No hay resultados
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BImg, BCardBody, BCardTitle, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { timestampToDate, title } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    BCardBody,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      timestampToDate,
      title,
    }
  },
  setup() {
    const getCalendarDates = (arry, type) => arry.find(item => item.tipo === parseInt(type, 10))

    return {
      getCalendarDates,

      timestampToDate,
      title,
    }
  },
}
</script>
